import env from '@config/env';
import CryptoJS from 'crypto-js';

const getKey = () => env.ENCRYPTION_KEY;

/** Plaintext JWT pasted into Application → Local Storage (optional quotes / Bearer). */
const asPlainJwt = (value) => {
  if (value == null) return null;
  let token = String(value).trim();
  if (!token) return null;
  if (
    (token.startsWith('"') && token.endsWith('"')) ||
    (token.startsWith("'") && token.endsWith("'"))
  ) {
    token = token.slice(1, -1).trim();
  }
  if (/^bearer\s+/i.test(token)) {
    token = token.replace(/^bearer\s+/i, '').trim();
  }
  if (token.startsWith('eyJ') && token.split('.').length === 3) return token;
  return null;
};

export const encryptedStorage = {
  setItem(key, value) {
    try {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      const encrypted = CryptoJS.AES.encrypt(stringValue, getKey()).toString();
      localStorage.setItem(key, encrypted);
    } catch (error) {
      console.error('EncryptedStorage setItem error:', error);
    }
  },

  getItem(key) {
    try {
      const encrypted = localStorage.getItem(key);
      if (!encrypted) return null;

      // Read a pasted JWT before AES decrypt — CryptoJS turns invalid ciphertext
      // into garbage Utf8, which would hide the new token and keep using a cookie.
      const rawJwt = asPlainJwt(encrypted);
      if (rawJwt) return rawJwt;

      const bytes = CryptoJS.AES.decrypt(encrypted, getKey());
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      const decryptedJwt = asPlainJwt(decrypted);
      if (decryptedJwt) return decryptedJwt;

      if (!decrypted) return null;
      try {
        if (/^-?\d+(\.\d+)?([eE][+-]?\d+)?$/.test(decrypted)) {
          return decrypted;
        }
        return JSON.parse(decrypted);
      } catch {
        return decrypted;
      }
    } catch (error) {
      console.error('EncryptedStorage getItem error:', error);
      return null;
    }
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  },
};

export default encryptedStorage;
